export const ROLE_SYSTEM = 'SYSTEM_ROOT';
export const ROLE_PARTNER_OWNER = 'PARTNER_USER_OWNER';
export const ROLE_PARTNER_MANAGER = 'PARTNER_USER_MANAGER';
export const ROLE_PARTNER_REGISTERED = 'PARTNER_USER_REGISTERED';
export const ROLE_TERMINAL = 'PARTNER_USER_TERMINAL';
export const TOKEN_TYPE_PARTNER_VERIFY_PHONE = 'PARTNER_VERIFY_PHONE';
export const ROLE_ELEMENT_OWNER = 'owner';
export const ROLE_ELEMENT_MANAGER = 'manager';
export const ROLE_ELEMENT_TERMINAL = 'terminal';
